import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'

export class NftTransactionRecord {
  constructor (record) {
    this._record = record

    this.id = _get(record, 'id', '')
    this.userId = _get(record, 'userId', '')
    this.address = _get(record, 'address', '')
    this.role = _get(record, 'role', '')
    this.action = _get(record, 'action', '')
    this.status = _get(record, 'status', '')
    this.retryCount = _get(record, 'retryCount', 0)
    this.txHash = _get(record, 'txHash', '')
    this.chain = _get(record, 'chain', '')
    this.chainName = _get(record, 'chainName', '')
    this.chainId = _get(record, 'chainId', '')
    this.explorerUrl = _get(record, 'explorerUrl', '')
    this.createdAt = new Date(_get(record, 'createdAt', new Date()))
    this.reason = _get(record, 'reason', '')
  }

  get isNotEmptyTxHash () {
    return !_isEmpty(this.txHash)
  }
}
